import { createParticipantsFormFieldErrorEvent } from '@/scopes/checkout/domain/analytics/index'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import * as React from 'react'
import { FieldError } from 'react-hook-form'

export function useSendFormFieldValidationEvent(fieldName: string, error: FieldError | undefined) {
  const fieldErrorType = error?.type as string | undefined
  const { sendEvent } = useAnalytics()

  const sendFieldValidationEvent = React.useCallback(() => {
    if (!fieldErrorType)
      return

    sendEvent(
      createParticipantsFormFieldErrorEvent({
        element: 'booking participants form',
        description: fieldErrorType,
        type: fieldName,
        interaction: true,
      }),
    )
  }, [sendEvent, fieldName, fieldErrorType])

  React.useEffect(() => {
    if (!fieldErrorType)
      return
    sendFieldValidationEvent()
  }, [sendFieldValidationEvent, fieldErrorType])

  return {
    sendFieldValidationEvent,
  }
}
